// extracted by mini-css-extract-plugin
export default {"container":"competition-closed_container","wrapper":"competition-closed_wrapper","fadeIn":"competition-closed_fadeIn"};